import BillingCliMasterCustomerIndex from "@/components/billing/cli_master_customer/BillingCliMasterCustomerIndex.vue";

let routesBillingCliMasterCustomer= [
    {
        path: '',
        meta: {
          title: "Billing CLI Master Customer",
        },
        name: "BillingCliMasterCustomerIndex",
        component: BillingCliMasterCustomerIndex
    },
    
]

export default routesBillingCliMasterCustomer
  